import {ChangeDetectorRef, Component, OnInit, Input} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";
import {OfferThumbnailInfo} from "~/app/core/model/offer-thumbnail-info";
import {OfferInfo} from "~/app/core/model/offer-info";
import {OfferService} from "~/app/core/offer-service/offer.service";
import {HomeComponent} from "~/app/components/home/home.component";
import {AddressInfo} from "~/app/core/model/address-info";
import {LocationInfo} from "~/app/core/model/location-info";
import {CoreService} from "~/app/core/core.service";
import {UserInfo} from '~/app/core/model/user-info';
import {UserProfileService} from "~/app/core/user-profile-service/user-profile.service";

@Component({
    selector: "medium-offer-view",
    templateUrl: "./medium-offer-view.component.html",
    styleUrls: ["./medium-offer-view.component.scss"]
})
export class MediumOfferViewComponent implements OnInit {
  @Input() offer: OfferInfo;
  latitude: number = null;
  longitude: number = null;
  findingLocation: boolean = false;
  nearestAddress: AddressInfo;
  nearestAddressDistance: number = null;
  userInfo: UserInfo;
  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly offerService: OfferService,
    private homeComponent: HomeComponent,
    private readonly core: CoreService,
    private readonly userProfileService: UserProfileService,
  ) {
  }

  ngOnInit(): void {
    this.findNearestLocation();
    this.userInfo = this.userProfileService.userInfo;
  }

  public setFavorite() {
    this.offerService.favoriteOffer(this.offer.id);
    this.offer.favorite = true;
    console.log("TODO update 'My Favorites' list");
  }

  public unsetFavorite() {
    this.offerService.unfavoriteOffer(this.offer.id);
    this.offer.favorite = false;
    console.log("TODO update 'My Favorites' list");
  }

  public displayOffer(offerID: number) {
    this.homeComponent.displayOffer(offerID);
  }

  calculateDistance(address: AddressInfo): number {
    const distance = this.milesAwayPrecise(address);
    if (distance) {
      return distance > 1 ? Math.round(distance) : Math.round(distance * 10) / 10;
    }
    return null;
  }

  milesAwayPrecise(address: AddressInfo): number {
    if (this.hasMilesAway(address)) {
      const distance = LocationInfo.milesAway(
        { longitude: address.longitude, latitude: address.latitude },
        { longitude: this.longitude, latitude: this.latitude }
      );
      console.log(address.city + " distance: " + distance);
      return distance;
    }
    return null;
  }

  hasMilesAway(address: AddressInfo): boolean {
    return !!address.latitude && !!address.longitude && !!this.longitude && !!this.latitude;
  }

  findNearestLocation() {
    this.findingLocation = true;
    this.core.api.location_getLocationInfo().then(locationInfo => {
      this.longitude = locationInfo.longitude;
      this.latitude = locationInfo.latitude;
      this.findingLocation = false;
      for (let address of this.offer.addresses) {
        let calculatedDistance = this.calculateDistance(address);
        if (this.nearestAddressDistance == null || calculatedDistance < this.nearestAddressDistance) {
          this.nearestAddressDistance = calculatedDistance;
          this.nearestAddress = address;
        }
      }
    }, (error) => {
      console.log("unable to get location");
      this.findingLocation = false;
    });
  }

  getMapUrl(address: AddressInfo) {
    let urlScheme = 'maps';
    if /* if we're on iOS, open in Apple Maps */
    ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPad") != -1) || (navigator.platform.indexOf("iPod") != -1))
      urlScheme = "maps";
    else
      urlScheme = "https";
    // return urlScheme + "://maps.google.com/maps?daddr="+this.nearestAddress.latitude+","+this.nearestAddress.longitude+"&amp;ll=";
    return urlScheme + "://maps.google.com/maps/dir/"+this.latitude+","+this.longitude+"/"+address.latitude+","+address.longitude;

  }

  showMap(address: AddressInfo) {
    window.open(this.getMapUrl(address), "_blank");
  }
}
